import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const savedCart = localStorage.getItem('amc_lab_cart');
    if (savedCart) {
      setCartItems(JSON.parse(savedCart));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    localStorage.setItem('amc_lab_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = useCallback((test) => {
    setCartItems((prev) => {
      const exists = prev.find((item) => item.test_name === test.test_name);
      if (exists) {
        return prev;
      }
      return [...prev, test];
    });
  }, []);

  const removeFromCart = useCallback((testName) => {
    setCartItems((prev) => prev.filter((item) => item.test_name !== testName));
  }, []);

  const clearCart = useCallback(() => {
    setCartItems([]);
  }, []);

  const getTotal = useCallback(() => {
    return cartItems.reduce((sum, item) => sum + item.price, 0);
  }, [cartItems]);

  const contextValue = useMemo(() => ({
    cartItems,
    addToCart,
    removeFromCart,
    clearCart,
    getTotal,
  }), [cartItems, addToCart, removeFromCart, clearCart, getTotal]);

  return (
    <CartContext.Provider value={contextValue}>
      {children}
    </CartContext.Provider>
  );
};